export default {
  showTCPrice: false,
} 